import {request} from '@/assets/js/request.js'
import {requestSpec} from '@/assets/js/checkLogin.js'
let fixUrl='app20/community-service/community/'
//游记详情
const getTravelDetail = (id) => {
    return request({
        method: 'post',
        url: `${fixUrl}api/travelNotes/view/${id}`,
        data: {},
    })
 }
 //攻略详情
const getStrategyDetail = (id) => {
    return request({
        method: 'get',
        url: `${fixUrl}api/strategyInfo/content/${id}`,
        data: {},
    })
 }
const getShareInfo = (data) => {
    return request({
        method: 'post',
        url: `${fixUrl}api/share/getShareInfo`,
        data
    })
 }
const getComment = (data) => {
    return request({
        method: 'post',
        url: `${fixUrl}api/reviewinfo/displayReview`,
        data
    })
 }
const admireCheck = (data) => {
    return request({
        method: 'post',
        url: `${fixUrl}api/admire/checkDid`,
        data
    })
 }
const collectCheck = (data) => {
    return request({
        method: 'post',
        url: `${fixUrl}api/collect/checkDid`,
        data
    })
 }
const collectOperate = (data) => {
    return request({
        method: 'post',
        url: `${fixUrl}api/collect/operate`,
        data
    })
 }
const admireOperate = (data) => {
    return request({
        method: 'post',
        url: `${fixUrl}api/admire/operate`,
        data
    })
}
const checkLogin = ()=>{
    return request({
        method: 'get',
        url: `app20/user-base-service/user20/api/userSessionInfo`,
    })
}
// 特殊判断 勿用
const checkLogin2 = ()=>{
  return requestSpec({
      method: 'get',
      url: `app20/user-base-service/user20/api/userSessionInfo`,
  })
}
 export {
    getTravelDetail,
    getStrategyDetail,
    getShareInfo,
    getComment,
    admireCheck,
    collectCheck,
    collectOperate,
    admireOperate,
    checkLogin,
    checkLogin2
 }


// WEBPACK FOOTER //
// ./src/api/discover.js